var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.762,
    height: 71.805,
    viewBox: "0 0 71.762 71.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27153",
    "data-name": "Path 27153",
    d: "M35.838,0C14.981.349-.03,16.6,0,35.877A35.5,35.5,0,0,0,35.824,71.8,35.569,35.569,0,0,0,71.762,35.834,35.876,35.876,0,0,0,35.838,0Zm17.37,25.617q-2.825,13.364-5.682,26.725a5.517,5.517,0,0,1-.413,1.251,1.436,1.436,0,0,1-1.833.848,4.1,4.1,0,0,1-1.317-.605c-2.7-1.973-5.376-3.976-8.058-5.965-.19-.14-.383-.276-.609-.439-1.377,1.331-2.718,2.622-4.052,3.919a3.107,3.107,0,0,1-2.113,1.058c.017-.216.037-.426.053-.635.2-2.642.406-5.28.592-7.925a1.36,1.36,0,0,1,.476-.971q8.025-7.306,16.032-14.638c.01-.01.027-.017.033-.03.123-.23.246-.462.366-.7-.3-.01-.659-.14-.878-.017-.935.519-1.833,1.111-2.738,1.68Q36.2,33.5,29.337,37.817c-1.384.875-2.775,1.743-4.155,2.625a.854.854,0,0,1-.788.106c-2.938-.9-5.879-1.793-8.816-2.691a2.482,2.482,0,0,1-.639-.3.755.755,0,0,1-.259-1.174,3.77,3.77,0,0,1,1.281-.985c1.327-.582,2.688-1.081,4.042-1.6l24.476-9.442q3.109-1.2,6.221-2.4a5.119,5.119,0,0,1,.536-.19,1.675,1.675,0,0,1,2.266,1.61A10.053,10.053,0,0,1,53.207,25.617Z",
    transform: "translate(0 0)",
    fill: "#f77f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.550194e7613fa17066daf74ae4446f3e.svg";
export { ForwardRef as ReactComponent };